//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageUploader from "../../components/ImageUploader";

export default {
  name: "my-appointDetail",
  components: {ImageUploader},
  data() {
    return {
      id: 0,
      deliveryRecord: {
        // dataStatus: 0,
        // appointmentStatus: 0
        projectName: '',
        roomName: '',
        time: '',
        name: '',
        mobile: ''
      },
      loading: false,
    }
  },
  computed: {
    statusStr() {
      if (this.deliveryRecord.dataStatus > 0 && this.deliveryRecord.appointmentStatus === 0) {
        if (this.deliveryRecord.dataStatus === 1) {
          return '资料待提交'
        }
        if (this.deliveryRecord.dataStatus === 2) {
          // return '材料已提交'
          return '已提交待审核'
        }
        if (this.deliveryRecord.dataStatus === 3) {
          // return '材料已审核'
          return '已审核待预约'
        }

      } else if (this.deliveryRecord.appointmentStatus > 0) {

        if (this.deliveryRecord.appointmentStatus === 1) {
          return '待预约'
        }
        if (this.deliveryRecord.appointmentStatus === 2) {
          return '已预约待确认'
        }
        if (this.deliveryRecord.appointmentStatus === 3) {
          return '预约已确认'
        }
      } else {
        return " "
      }
    }
  },
  methods: {
    getDeliveryRecordById() {
      const vm = this;
      this.loading = true;
      abp.ajax.get('/api/services/app/DeliveryRecord/GetDeliveryRecordById?id=' + this.id).then(res => {
        this.deliveryRecord = {};
        this.deliveryRecord = res.data.result;
        this.deliveryRecord.projectName = this.deliveryRecord.projectName != null ? this.deliveryRecord.projectName : '';
        this.deliveryRecord.roomName = this.deliveryRecord.roomName != null ? this.deliveryRecord.roomName : '';
        this.deliveryRecord.time = this.deliveryRecord.time != null ? this.deliveryRecord.time : '';
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  created() {
    this.id = parseInt(this.$route.params.id) || 0;
    if (this.id > 0) {
      this.getDeliveryRecordById()
    }
  }

}
